import {START, INIT_CANVAS, SUCCESS, FAIL} from "../constants/action-types";
import Mediator from "../services/Mediator";
import {toggleStaticObjects} from "./toggle-static-objects";
import {getDesignFromLocalStorage} from "../services/lib/save-design";
import {restoreDesign} from "./restore-design";

export const initCanvas = (options) => {
  return (dispatch, getState) => {
    dispatch({
      type: INIT_CANVAS + START
    });
    try {
      Mediator.initCanvas(options);
      dispatch({
        type: INIT_CANVAS + SUCCESS
      });
      const {
        condition,
        product: {
          id,
          meta: {product}
        }
      } = getState();
      const designs = getDesignFromLocalStorage(product, id);
      if (designs) {
        dispatch(restoreDesign(designs));
      }

      const hasStatic =
        condition.design &&
        condition.design.objects &&
        condition.design.objects.filter((o) => o.static).length;
      if (!hasStatic) {
        dispatch(toggleStaticObjects(condition));
      }
    } catch (e) {
      dispatch({
        type: INIT_CANVAS + FAIL,
        error: `Произошла ошибка`
      });
      throw e;
    }
  };
};
